/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonitoringWellTreeView } from './MonitoringWellTreeView';
import {
    MonitoringWellTreeViewFromJSON,
    MonitoringWellTreeViewFromJSONTyped,
    MonitoringWellTreeViewToJSON,
} from './MonitoringWellTreeView';

/**
 * 
 * @export
 * @interface WellPadTreeView
 */
export interface WellPadTreeView {
    /**
     * 
     * @type {number}
     * @memberof WellPadTreeView
     */
    padId?: number;
    /**
     * 
     * @type {string}
     * @memberof WellPadTreeView
     */
    padTitle: string;
    /**
     * 
     * @type {Array<MonitoringWellTreeView>}
     * @memberof WellPadTreeView
     */
    wells?: Array<MonitoringWellTreeView>;
}

/**
 * Check if a given object implements the WellPadTreeView interface.
 */
export function instanceOfWellPadTreeView(value: object): value is WellPadTreeView {
    if (!('padTitle' in value) || value['padTitle'] === undefined) return false;
    return true;
}

export function WellPadTreeViewFromJSON(json: any): WellPadTreeView {
    return WellPadTreeViewFromJSONTyped(json, false);
}

export function WellPadTreeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): WellPadTreeView {
    if (json == null) {
        return json;
    }
    return {
        
        'padId': json['padId'] == null ? undefined : json['padId'],
        'padTitle': json['padTitle'],
        'wells': json['wells'] == null ? undefined : ((json['wells'] as Array<any>).map(MonitoringWellTreeViewFromJSON)),
    };
}

export function WellPadTreeViewToJSON(value?: WellPadTreeView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'padId': value['padId'],
        'padTitle': value['padTitle'],
        'wells': value['wells'] == null ? undefined : ((value['wells'] as Array<any>).map(MonitoringWellTreeViewToJSON)),
    };
}

